type TaggableViewer = {
	company?: {id?: string | null} | null;
};

export type SentryScopeTags = {
	company_id?: string;
};

/**
 * The backend id inside a Relay global id, or undefined if it does not hold one.
 *
 * `atob` throws on input that is not base64, and this runs inside Sentry scope
 * configuration where a throw would cost every tag and the user context set
 * beside them — so an unreadable id yields no tag rather than an exception.
 */
const backendIdOf = (globalId: string | null | undefined, type: string): string | undefined => {
	if (!globalId) return undefined;
	try {
		const decoded = atob(globalId);
		return decoded.startsWith(`${type}:`) ? decoded.slice(type.length + 1) : undefined;
	} catch {
		return undefined;
	}
};

/**
 * The tags that make a company findable in Sentry.
 *
 * Sentry indexes tags and nothing else — user context is attached to an event but is
 * not searchable — so anything we want to filter or alert on has to be a tag.
 */
export const sentryScopeTags = (viewer: TaggableViewer): SentryScopeTags => {
	const companyId = backendIdOf(viewer?.company?.id, 'Company');

	return companyId ? {company_id: companyId} : {};
};
